(function(){
  'use strict';
  var VERSION = 'p11dz391-mobile-launch-hardening';
  if (window.DSDMobileLaunchHardening && window.DSDMobileLaunchHardening.version === VERSION) return;

  var selectors = [
    '.dsd-user-profile', '.dsd-feed-shell', '.dsd-following-feed', '.dsd-notification-center',
    '.dsd-messaging-center', '.dsd-stories-runtime', '.dsd-safety-center', '.dsd-founder-operations',
    '.dsd-search-center', '.dsd-modal', '.dsd-overlay-panel', '[data-dsd-immersive-overlay]', '.dsd-msg384__messages[data-dsd-message-thread-scroll]'
  ];
  var state = {
    version: VERSION,
    startedAt: new Date().toISOString(),
    scans: 0,
    mobileWidth: null,
    safeAreaApplied: true,
    surfacesSeen: {},
    touchTargetsMarked: 0,
    clippedCandidates: [],
    activationLock: 'no-firebase-no-realtime-no-media-pipeline-changes'
  };

  function claim(name, data){
    try {
      var r = window.DSDRegistry || window.DSDRuntimeRegistry || window.DSDArchitectureRegistry;
      if (r && typeof r.claim === 'function') r.claim(name, 'MobileLaunchHardening', data || {});
      if (r && typeof r.event === 'function') r.event('MOBILE_LAUNCH_HARDENING', data || {});
    } catch(e) {}
  }

  function markSurface(el){
    if (!el || !el.classList) return;
    var key = selectors.find(function(sel){ try { return el.matches(sel); } catch(e){ return false; } }) || el.tagName;
    state.surfacesSeen[key] = (state.surfacesSeen[key] || 0) + 1;
    el.setAttribute('data-dsd-mobile-hardened', 'p11dz391');
  }

  function checkClip(el){
    try {
      var rect = el.getBoundingClientRect();
      if (!rect || !rect.width) return;
      if (rect.right > window.innerWidth + 2 || rect.left < -2) {
        var id = el.className ? String(el.className).slice(0,80) : el.tagName;
        if (state.clippedCandidates.indexOf(id) === -1) state.clippedCandidates.push(id);
      }
    } catch(e) {}
  }

  function scan(){
    state.scans += 1;
    state.mobileWidth = window.innerWidth || null;
    var nodes = [];
    selectors.forEach(function(sel){
      try { nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll(sel))); } catch(e) {}
    });
    nodes.forEach(function(el){ markSurface(el); checkClip(el); });
    try {
      document.querySelectorAll('.dsd-social-shell button, .dsd-user-profile button, .dsd-feed-shell button, .dsd-notification-center button, .dsd-messaging-center button, .dsd-stories-runtime button, .dsd-safety-center button, .dsd-founder-operations button, .dsd-search-center button').forEach(function(btn){
        if (!btn.hasAttribute('data-dsd-touch-target')) {
          btn.setAttribute('data-dsd-touch-target', 'p11dz391');
          state.touchTargetsMarked += 1;
        }
      });
    } catch(e) {}
    claim('mobile-launch-hardening:scan', snapshot());
  }

  function snapshot(){
    return {
      version: state.version,
      scans: state.scans,
      mobileWidth: state.mobileWidth,
      safeAreaApplied: state.safeAreaApplied,
      surfacesSeen: state.surfacesSeen,
      touchTargetsMarked: state.touchTargetsMarked,
      clippedCandidates: state.clippedCandidates.slice(0, 20),
      activationLock: state.activationLock
    };
  }

  window.DSDMobileLaunchHardening = { version: VERSION, scan: scan, snapshot: snapshot, state: state };
  document.addEventListener('DOMContentLoaded', scan, { once: true });
  window.addEventListener('resize', function(){ clearTimeout(window.__dsdMobileHardeningResize); window.__dsdMobileHardeningResize = setTimeout(scan, 120); }, { passive: true });
  window.addEventListener('orientationchange', function(){ setTimeout(scan, 240); }, { passive: true });
  document.addEventListener('shopify:section:load', function(){ setTimeout(scan, 80); });
  claim('mobile-launch-hardening:boot', { version: VERSION });
})();
